/**
 * @generated SignedSource<<462d6008151ce5971bdb9cf303401a8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useNotificationsConfig_viewer$data = {
  readonly onSessionSellerChargesEnabled: boolean | null;
  readonly " $fragmentType": "useNotificationsConfig_viewer";
};
export type useNotificationsConfig_viewer$key = {
  readonly " $data"?: useNotificationsConfig_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNotificationsConfig_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useNotificationsConfig_viewer",
  "selections": [
    {
      "alias": "onSessionSellerChargesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "onSessionSellerBillingStatementCharges"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"onSessionSellerBillingStatementCharges\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "16915e38c01c2233ef717c801ad6caef";

export default node;
